module.exports = __webpack_public_path__ + "img/marketplace_TikTok.5de27d0f.svg";